// action types
export const UPDATE_PERSONAL_INFO = "updateUserPersonalInfo";
export const UPDATE_ACCOUNT_INFO = "updateUserAccountInfo";

// mutation types
export const SET_PERSONAL_INFO = "setPersonalInfo";
export const SET_ACCOUNT_INFO = "setAccountInfo";
export const RESET_PROFILE_STATE = "resetProfileState";

const getDefaultState = () => ({
  user_personal_info: {
    photo: "media/empty_user.png",
    name: "Cargando...",
    surname: "Cargando...",
    company_name: "Cargando...",
    job: "Cargando...",
    email: "Cargando...",
    phone: "Cargando...",
    company_site: "Cargando..."
  },
  user_account_info: {
    username: "Cargando...",
    email: "Cargando...",
    language: "Cargando...",
    time_zone: "Cargando...",
    communication: {
      email: true,
      sms: true,
      phone: false
    },
    verification: true
  }
});

const state = getDefaultState();

const getters = {
  currentUserPersonalInfo(state) {
    return state.user_personal_info;
  },

  currentUserAccountInfo(state) {
    return state.user_account_info;
  },

  currentUserPhoto(state) {
    return state.user_personal_info.photo;
  }
};

const actions = {
  [UPDATE_PERSONAL_INFO](context, payload) {
    context.commit(SET_PERSONAL_INFO, payload);
  },
  [UPDATE_ACCOUNT_INFO](context, payload) {
    context.commit(SET_ACCOUNT_INFO, payload);
  }
};

const mutations = {
  [RESET_PROFILE_STATE](state) {
    Object.assign(state, getDefaultState());
  },
  [SET_PERSONAL_INFO](state, user_personal_info) {
    state.user_personal_info = user_personal_info;
  },
  [SET_ACCOUNT_INFO](state, user_account_info) {
    state.user_account_info = user_account_info;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
